var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-4.126 -7.659 35.759 45.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-logo_svg__a",
    x1: 14.09,
    x2: -5.9,
    y1: 1.87,
    y2: 21.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#008fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00acff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00c0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00cdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00d1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-logo_svg__b",
    x1: 26.45,
    x2: -2.37,
    y1: 15.32,
    y2: 15.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8a00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-logo_svg__c",
    x1: 17.69,
    x2: -9.41,
    y1: 18.05,
    y2: 45.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b11162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-logo_svg__d",
    x1: -3.19,
    x2: 8.92,
    y1: -8.29,
    y2: 3.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#328e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2d9571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15bd74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06d575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00de76"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-logo_svg__a)",
    d: "M.55.48A2.39 2.39 0 0 0 0 2.15v26.34a2.41 2.41 0 0 0 .55 1.67l.09.09 14.75-14.76v-.35L.64.39z",
    transform: "translate(.004)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-logo_svg__b)",
    d: "m20.31 20.41-4.92-4.92v-.35l4.92-4.91.11.06 5.83 3.31c1.67.94 1.67 2.49 0 3.44l-5.83 3.31z",
    transform: "translate(.004)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-logo_svg__c)",
    d: "m20.42 20.35-5-5L.55 30.16a2 2 0 0 0 2.45.07l17.39-9.88",
    transform: "translate(.004)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-logo_svg__d)",
    d: "M20.42 10.29 3 .4A1.93 1.93 0 0 0 .55.48l14.84 14.84z",
    transform: "translate(.004)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m20.314 20.24-17.31 9.82a2 2 0 0 1-2.39 0l-.09.09.09.09a2 2 0 0 0 2.39 0l17.39-9.88z",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M.554 30a2.43 2.43 0 0 1-.55-1.68v.17a2.41 2.41 0 0 0 .55 1.67l.09-.09zm25.7-13.14-5.94 3.38.11.11 5.83-3.35a2.11 2.11 0 0 0 1.25-1.72 2.21 2.21 0 0 1-1.25 1.58z",
    className: "google-play-logo_svg__cls-7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.004.58 23.25 13.19a2.2 2.2 0 0 1 1.25 1.55 2.09 2.09 0 0 0-1.25-1.72L3.004.4c-1.64-.94-3-.16-3 1.75v.17c0-1.9 1.36-2.69 3-1.74z",
    opacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayLogo);
export default __webpack_public_path__ + "static/media/google-play-logo.8efb591e9ed5f3e3fcf63fe54d54d188.svg";
export { ForwardRef as ReactComponent };